export default "__VITE_ASSET__BSD6U5CT__"